import PropTypes from "prop-types";

export const BtnReenvio = ({ dato, id, reenviarContrato }) => {
  return dato === "1" ? (
    <button
      onClick={e => {
        e.stopPropagation();
        reenviarContrato(id);
      }}
      className="btn"
      style={{
        fontSize: "11px",
        padding: "4px 12px",
        borderRadius: "12px",
        backgroundColor: "#1976d2",
        color: "#ffffff",
        border: "none",
        fontWeight: 600,
        boxShadow: "0 2px 4px rgba(25, 118, 210, 0.3)",
        transition: "all 0.2s ease",
        cursor: "pointer",
        letterSpacing: "0.3px",
      }}
      onMouseEnter={e => {
        e.currentTarget.style.backgroundColor = "#1565c0";
        e.currentTarget.style.boxShadow = "0 4px 6px rgba(25, 118, 210, 0.4)";
        e.currentTarget.style.transform = "translateY(-1px)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.backgroundColor = "#1976d2";
        e.currentTarget.style.boxShadow = "0 2px 4px rgba(25, 118, 210, 0.3)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      Reenviar
    </button>
  ) : null;
};

BtnReenvio.propTypes = {
  dato: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reenviarContrato: PropTypes.func.isRequired,
};